/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PermissionDto } from '../models/permission-dto';


/**
 * API to manage permissions for merchant's individual users or API consumers/clients.
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation permissionsSearch
   */
  static readonly PermissionsSearchPath = '/v1/permissions';

  /**
   * Permissions: core.roles.search-permissions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionsSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsSearch$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PermissionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionsSearchPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PermissionDto>>;
      })
    );
  }

  /**
   * Permissions: core.roles.search-permissions
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionsSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsSearch(params?: {
  }): Observable<Array<PermissionDto>> {

    return this.permissionsSearch$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PermissionDto>>) => r.body as Array<PermissionDto>)
    );
  }

  /**
   * Path part for operation permissionsSearchForCurrentUser
   */
  static readonly PermissionsSearchForCurrentUserPath = '/v1/permissions/search-for-current-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionsSearchForCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsSearchForCurrentUser$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PermissionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionsSearchForCurrentUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PermissionDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionsSearchForCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsSearchForCurrentUser(params?: {
  }): Observable<Array<PermissionDto>> {

    return this.permissionsSearchForCurrentUser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PermissionDto>>) => r.body as Array<PermissionDto>)
    );
  }

}
